import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import Step2SelectWhatsappConnection from "../broadcast/steps/Step2SelectWhatsappConnection";

type VoiceCallConfig = {
  id: string;
  phoneNumberId: string;
  concurrency?: {
    reserved: number;
    enabled: boolean;
    expirationMinutes: number;
    whatsappFallback: boolean;
  } | null;
} | null;

type Props = {
  selectedChannel: "whatsapp" | "voice";
  onChannelChange: (channel: "whatsapp" | "voice") => void;
  selectedWhatsappConnectionId: string;
  onWhatsappLineSelect: (id: string) => void;
  voiceCallConfig: VoiceCallConfig;
  isLoadingVoiceConfig: boolean;
};

const RecaudoChannelSelector = ({
  selectedChannel,
  onChannelChange,
  selectedWhatsappConnectionId,
  onWhatsappLineSelect,
  voiceCallConfig,
  isLoadingVoiceConfig,
}: Props) => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-lg font-bold">Selecciona el canal de contacto</p>
        <p className="mb-4 text-sm text-gray-600">
          Elige cómo quieres contactar a los compradores en mora.
        </p>
      </div>

      <Tabs
        value={selectedChannel}
        onValueChange={(v) => onChannelChange(v as "whatsapp" | "voice")}
      >
        <TabsList variant="solid" className="mb-4">
          <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>
          <TabsTrigger value="voice">Llamada de voz</TabsTrigger>
        </TabsList>

        <TabsContent value="whatsapp">
          <Step2SelectWhatsappConnection
            selectedWhatsappConnectionId={selectedWhatsappConnectionId}
            onSelect={onWhatsappLineSelect}
          />
        </TabsContent>

        <TabsContent value="voice">
          {isLoadingVoiceConfig ? (
            <div className="flex items-center justify-center py-12">
              <div className="flex flex-col items-center gap-4">
                <Spinner size="xl" />
                <p className="text-gray-600">Verificando configuración de voz...</p>
              </div>
            </div>
          ) : !voiceCallConfig ? (
            <Card className="border-red-200 bg-red-50">
              <CardContent className="p-6">
                <p className="text-sm text-red-700">
                  No se encontró una configuración de voz para cobranza. Contacta a soporte para
                  activar este canal.
                </p>
              </CardContent>
            </Card>
          ) : (
            <Card className="border-purple-200 bg-purple-50">
              <CardContent className="p-6 flex flex-col gap-3">
                <p className="font-medium text-purple-900">Configuración de llamadas</p>
                <div className="flex flex-col gap-1">
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Línea de salida:</span>{" "}
                    {voiceCallConfig.phoneNumberId}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Capacidad máxima:</span>{" "}
                    {voiceCallConfig.concurrency?.reserved ?? 10} llamadas simultáneas
                  </p>
                </div>
              </CardContent>
            </Card>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default RecaudoChannelSelector;
